module.exports = __webpack_public_path__ + "img/ico_order_regular.da40910.png";